import type { UserPermissionsFacade } from 'redux/modules/user.types';

/**
 * Show the tag settings page to users who can read tags and have at least one write permission to
 * them (create, update or delete).
 */
export const canViewTagSettings = (permissions: UserPermissionsFacade) =>
  permissions.canRead.tags &&
  (permissions.canCreate.tags || permissions.canUpdate.tags || permissions.canDelete.tags);

/**
 * Show the workspace settings page to users who can read accounts and have at least one write
 * permission to them (update, delete or change ownership).
 */
export const canViewWorkspaceSettings = (permissions: UserPermissionsFacade) =>
  permissions.canRead.workspace &&
  (permissions.canUpdate.workspace ||
    permissions.canDelete.workspace ||
    permissions.canChangeOwnershipOf.workspace);
